import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

const Tag = ({ children, type, onClick }) => {
  return (
    <div
      data-type={type}
      className={cn(styles.root, {
        [styles.isInteractive]: typeof onClick === 'function',
      })}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

Tag.types = { base: 'base', baseInverted: 'base-inverted' };

export default Tag;
